import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { ATTRIBUTE_FRAGMENT } from './attribute'

import type { AbTestsVariantsSchemaDTO } from 'features/ab-tests/api/types/abTestsVariantsSchemaDTO'

export const VIEWABILITY_TOOLS_FRAGMENT: TypedDocumentNode<
  AbTestsVariantsSchemaDTO['viewabilityTools']
> = gql`
  ${ATTRIBUTE_FRAGMENT}

  fragment abTestsVariantsViewabilityToolsFragment on AbTestsVariantsViewabilityTools {
    lazyLoading {
      lazyLoadType {
        ...abTestsVariantsAttributesFragment
      }
      lazyLoadTargetingPrebidAuctionEnabled {
        ...abTestsVariantsAttributesFragment
      }
      kvTargetingAndPrebidAuction {
        ...abTestsVariantsAttributesFragment
      }
      gamAdRequestMargin {
        ...abTestsVariantsAttributesFragment
      }
      gamAdRenderMargin {
        ...abTestsVariantsAttributesFragment
      }
      mobileScaling {
        ...abTestsVariantsAttributesFragment
      }
      label
    }
    label
  }
`
